import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevron-right",
  "use": "chevron-right-usage",
  "viewBox": "0 0 7 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 7 12\" id=\"chevron-right\"><path d=\"M.866 12 0 11.134 5.134 6 0 .866.866 0l6 6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol